import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import MyModal from "../../layout/MyModal";
import { Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import MyDivider from "../../layout/MyDivider";
import { useNavigate } from "react-router-dom";

export default function SystemError(props) {
  const errorTxt = props.errorTxt;
  const errorNum = props.errorNum;
  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (errorTxt) setShowError(true);
  }, [errorTxt]);

  const titleTxt = "Anteeksi häiriö";

  const title = (
    <div style={{ display: "flex" }}>
      <Typography variant="h6" component="div" gutterBottom color="primary">
        {titleTxt}
      </Typography>
      <ErrorOutlineIcon sx={{ fontSize: 20 }} />
    </div>
  );

  const handleClose = () => {
    console.log("navToFrontPage");
    navigate("/");
  };

  return (
    <MyModal
      isOpen={showError || false}
      title={title}
      showCloseButton={errorNum < 500}
      onClose={handleClose}
      dialogProps={{ maxWidth: "xs" }}
      closeButtonText="PALAA ETUSIVULLE">
      <Typography
        align="center"
        variant="body"
        component="div"
        gutterBottom
        color="primary"
        style={{ paddingTop: "12px" }}>
        {errorTxt}
      </Typography>
    </MyModal>
  );
}

SystemError.propTypes = {
  errorTxt: PropTypes.string,
  errorNum: PropTypes.number,
};
